import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';
import { EditPositionPreferencesSection } from '../edit-position-preferences-section/edit-position-preferences-section.component';
import STRING_KEYS from '../../../../language/keys';
import { SuggestionListContainer } from '../edit-position-dialog.styled';
import RequirementChip
  from '../../../../modules/create-position/components/create-position-requirement-chip/create-position-requirement-chip.component';
import { getEnumValuesInRange } from '../../../../utils';
import { getMatchingOrderedLevelsOfExperience } from '../../../../utils/positions';
import { LevelOfExperience } from '../../../../enums/level-of-experience.enum';
import { LevelOfExperienceSectionProps } from './level-of-experience-section';

const levelOfExperienceConfig = [
  { level: LevelOfExperience.StartingOut, title: '1-3 Years' },
  { level: LevelOfExperience.SomewhatExperienced, title: '3-5 Years' },
  { level: LevelOfExperience.HighlyExperienced, title: '5-10 Years' },
  { level: LevelOfExperience.IncrediblyExperienced, title: '10+ Years' },
];

export const LevelOfExperienceSection = ({
  levelsOfExperience,
  changeHandler,
}: LevelOfExperienceSectionProps): JSX.Element => {
  const { t: translate } = useTranslation();
  const selectedLevelsOfExperienceSet = useMemo(() => new Set(levelsOfExperience), [levelsOfExperience]);

  const onItemClick = (levelOfExperience: LevelOfExperience) => {
    if (selectedLevelsOfExperienceSet.has(levelOfExperience)) {
      selectedLevelsOfExperienceSet.delete(levelOfExperience);
      changeHandler(getMatchingOrderedLevelsOfExperience(Array.from(selectedLevelsOfExperienceSet)));
    } else {
      selectedLevelsOfExperienceSet.add(levelOfExperience);
      changeHandler(getEnumValuesInRange(LevelOfExperience, Array.from(selectedLevelsOfExperienceSet)));
    }
  };

  return (
    <EditPositionPreferencesSection
      emoji="🕰"
      title={ translate(STRING_KEYS.EDIT_POSITION_PREFERENCES_DIALOG.SECTIONS.LEVEL_OF_EXPERIENCE) }
    >
      <SuggestionListContainer>
        { levelOfExperienceConfig.map((item) => (
          <RequirementChip
            key={ item.level }
            title={ item.title }
            selected={ selectedLevelsOfExperienceSet.has(item.level) }
            onClick={ () => onItemClick(item.level) }
          />
        ))}
      </SuggestionListContainer>
    </EditPositionPreferencesSection>
  );
};
